import { List, Row, Col, Card, Input, Form, Button, Table, Select, message } from "antd";
import { LoaderSkeleton } from "../../components";
import React from "react";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import { CAB_ENGINE_OVERALL_PARAMETERS } from "constants/form-fields";
import CamEngineForm from "../../forms/cam-engine-form";
import { OrderedMap, Map } from "immutable";
import cx from "classnames";
import { CaseService, CompanyService } from "../../services";

const ListItem = List.Item;

class CamEngineTab extends React.Component {

    state = {
        // camAutomationData: {}
        camRuleEngineData: [],
        bankListing: [],
        selectedBank: null
    }

    componentDidMount() {
        CompanyService.cibilCommercialParam(this.props.caseId).then (({ ccdata }) => {
            CompanyService.camAutomation(this.props.caseId).then(({ data }) => {
                this.setState({
                    camAutomationData: data
                });
            }).catch((error) => {
                console.log("error", error);
            });
        }).catch((error) => {
            console.log("error", error);
        })
    }

    LABEL_LIST = () => (
        <List className={"f-grow-1 tabled-list tabled-list-header"} bordered>
            {CAB_ENGINE_OVERALL_PARAMETERS.map(_ => (
                <ListItem className={"form-field-list-item"} key={_.placeholder} style={{ display: "flex" }}>
                    {_.placeholder}
                </ListItem>
            )).toList()}
        </List>
    );

    runRuleEngine = () => {
        CompanyService.runCamRuleEngine(this.props.caseId).then(({ data }) => {
            this.setState({
                camRuleEngineData: data.message
            });
            let bankCode = [];
            data.message.map((item) => {
                bankCode.push(item.rule_name);
            });
            CompanyService.getLendingPartnersFilter(bankCode).then((bankData) => {
                this.setState({
                    bankListing: bankData.data
                });
            }).catch((err) => {
                console.log("error", err);
            });
        }).catch((error) => {
            console.log("error", error);
        });
    }

    submitBank = () => {
        if(this.state.selectedBank){
            let bankData = {
                bank: this.state.selectedBank
            };
            CompanyService.updateBankCaseDetail(this.props.caseId, bankData).then((data) => {
                message.success("Bank Updated Successfuly!");
                window.location.reload();
            }).catch((err) => {
                console.log("error", err);
            });
        } else{
            message.error("Please select bank");
        }
    }

    render() {
        const { anchors, caseDetail, company, scorecard } = this.props
        const dataCam = this.state.camAutomationData;
        let cibil_parameter;
        let commercial_cibil;

        let columns = [
            {
                title: 'Hytone',
                dataIndex: 'rule_name',
                key: 'rule_name'
              },
              {
                title: 'Result',
                dataIndex: 'result_message',
                key: 'result_message',
                render: text => <div className={"cam-status-div"}><p className={text === "Fail" ?  "cam-status-text-red" : "cam-status-text-green"}>{text}</p></div>,
              }
        ];
        if (dataCam) {
            cibil_parameter = dataCam["commercial_cibil_parameters"]["cibil_parameter"];
            commercial_cibil = dataCam["commercial_cibil_parameters"]["commercial_cibil"];
        }
        return (
            <Row className={"p-5"}>
                <Row>
                    <div className={"display-flex"}>
                        <h1 className={"ml-20"}>Underwriting Engine Input Parameters</h1>
                        <div className={"display-flex ml-20"}>
                            <div className={"display-flex"}>
                                <div className={"bankText-circle USFB-color"}>
                                    <p className={"m-0 fw-b"}>U</p>
                                </div>
                                <p className={"p-4"}>Ujjivan</p>
                            </div>
                            <div className={"display-flex"}>
                                <div className={"bankText-circle MF-color"}>
                                    <p className={"m-0 fw-b"}>M</p>
                                </div>
                                <p className={"p-4"}>Muthoot</p>
                            </div>
                            <div className={"display-flex"}>
                                <div className={"bankText-circle KSF-color"}>
                                    <p className={"m-0 fw-b"}>K</p>
                                </div>
                                <p className={"p-4"}>KSF</p>
                            </div>
                            <div className={"display-flex"}>
                                <div className={"bankText-circle LIQU-color"}>
                                    <p className={"m-0 fw-b"}>L</p>
                                </div>
                                <p className={"p-4"}>Liquiloans</p>
                            </div>
                        </div>
                    </div>
                </Row>
                <Col span={12} className={"p-10"}>
                    <Row>
                        <Col span={12} className={"p-10"}>
                            <Row>
                                <h4>Overall Parameters</h4>
                            </Row>
                        </Col>
                        <Col span={12} className={"p-10"} style={{ textAlign: "right" }}>
                            <Row>
                                <h4>Value of Parameters</h4>
                            </Row>
                        </Col>
                    </Row>
                    <Card
                        className={"padless-card"}
                    >
                        <div className={"d-flex tabled-list-container"}>
                            <Form
                                layout="vertical"
                                className={cx("form-vertical", "f-grow-1", "br-3")}>
                                <List bordered className={"tabled-list"}>
                                    {
                                        dataCam && Object.values(dataCam).map((item) => {
                                            if(item.sno){
                                                return (
                                                    <div className={"d-flex"}>
                                                        <ListItem
                                                            style={{ width: "50%", display: "inline-table" }}
                                                            className={"form-field-list-item border-none"}
                                                            key={item?.fact_name}>
                                                            <p style={{marginBottom: "0", lineHeight: "20px"}}>{item?.fact_name}</p>
                                                            {/* <div className={"display-flex"}>
                                                                {item.bank_code && item.bank_code.map((item) => {
                                                                    if(item === "MF" || item === "MFL"){
                                                                        return (
                                                                            <div>
                                                                                <div className={"MF-color bankText-bottom-circle"}>
                                                                                    <p className={"m-0 fw-b"}>{item.substring(0, 1)}</p>
                                                                                </div>
                                                                            </div>
                                                                        )
                                                                    }else{
                                                                        return (
                                                                            <div>
                                                                                <div className={item + "-color" + " " + "bankText-bottom-circle"}>
                                                                                    <p className={"m-0 fw-b"}>{item.substring(0, 1)}</p>
                                                                                </div>
                                                                            </div>
                                                                        )
                                                                    }
                                                                })}
                                                            </div> */}
                                                        </ListItem>
                                                        <ListItem
                                                            style={{ width: "50%" }}
                                                            className={"form-field-list-item"}
                                                            key={item?.fact_value}>
                                                            <Input value={item?.fact_value} disabled={true} />
                                                        </ListItem>
                                                    </div>
                                                );
                                            }
                                        })
                                    }
                                </List>
                            </Form>
                        </div>
                    </Card>
                </Col>
                <Col span={12} className={"p-10"}>
                    <Row>
                        <Col span={12} className={"p-10"}>
                            <Row>
                                <h4>Cibil Parameters</h4>
                            </Row>
                        </Col>
                        <Col span={12} className={"p-10"} style={{ textAlign: "right" }}>
                            <Row>
                                Value of parameters
                            </Row>
                        </Col>
                    </Row>
                    <Card
                        className={"padless-card cibil-param-fix-height"}
                    >
                        <div className={"d-flex tabled-list-container"}>
                            <Form
                                layout="vertical"
                                className={cx("form-vertical", "f-grow-1", "br-3")}>
                                <List bordered className={"tabled-list"}>
                                    {
                                        commercial_cibil && commercial_cibil.map((item) => {
                                            return (
                                                <div className={"d-flex"}>
                                                    <ListItem
                                                        style={{ width: "50%", display: "inline-table"}}
                                                        className={"maxHeight-auto"}
                                                        key={item?.parameter}>
                                                        <div className={"lh-16"}>
                                                            {item?.parameter}
                                                            <span style={{fontSize: "12px"}}>{item?.description}</span>
                                                        </div>
                                                        {/* <div className={"display-flex"}>
                                                            {item.bank_code && item.bank_code.map((item) => {
                                                                if(item === "MF" || item === "MFL"){
                                                                    return (
                                                                        <div>
                                                                            <div className={"MF-color bankText-bottom-circle"}>
                                                                                <p className={"m-0 fw-b"}>{item.substring(0, 1)}</p>
                                                                            </div>
                                                                        </div>
                                                                    )
                                                                }else{
                                                                    return (
                                                                        <div>
                                                                            <div className={item + "-color" + " " + "bankText-bottom-circle"}>
                                                                                <p className={"m-0 fw-b"}>{item.substring(0, 1)}</p>
                                                                            </div>
                                                                        </div>
                                                                    )
                                                                }
                                                            })}
                                                        </div> */}
                                                    </ListItem>
                                                    <ListItem
                                                        style={{ width: "50%", borderBottom: "1px solid #e8e8e8" }}
                                                        className={"form-field-list-item border-none"}
                                                        key={item?.value}>
                                                        <Input value={item?.value} disabled={true} />
                                                    </ListItem>
                                                </div>
                                            );
                                        })
                                    }
                                    {
                                        cibil_parameter && cibil_parameter.map((item) => {
                                            return (
                                                <React.Fragment>
                                                    <h3 style={{marginLeft: "10px"}}>{item.associate_name}</h3>
                                                    {
                                                        item.parameter && item.parameter.map((item) => {
                                                            return (
                                                                <div className={"d-flex"}>
                                                                    <ListItem
                                                                        style={{ width: "50%", display: "inline-table"  }}
                                                                        className={"maxHeight-auto"}
                                                                        key={item?.parameter}>
                                                                        {item?.parameter}
                                                                        <div className={"display-flex"}>
                                                                            {item.bank_code && item.bank_code.map((item) => {
                                                                                if(item === "MF" || item === "MFL"){
                                                                                    return (
                                                                                        <div>
                                                                                            <div className={"MF-color bankText-bottom-circle"}>
                                                                                                <p className={"m-0 fw-b"}>{item.substring(0, 1)}</p>
                                                                                            </div>
                                                                                        </div>
                                                                                    )
                                                                                }else{
                                                                                    return (
                                                                                        <div>
                                                                                            <div className={item + "-color" + " " + "bankText-bottom-circle"}>
                                                                                                <p className={"m-0 fw-b"}>{item.substring(0, 1)}</p>
                                                                                            </div>
                                                                                        </div>
                                                                                    )
                                                                                }
                                                                            })}
                                                                        </div>
                                                                    </ListItem>
                                                                    <ListItem
                                                                        style={{ width: "50%", borderBottom: "1px solid #e8e8e8" }}
                                                                        className={"form-field-list-item border-none"}
                                                                        key={item?.value}>
                                                                        <Input value={item?.value} disabled={true} />
                                                                    </ListItem>
                                                                </div>
                                                            );
                                                        })
                                                    }
                                                </React.Fragment>
                                            );
                                        })
                                    }
                                </List>
                            </Form>
                        </div>
                    </Card>
                    <div style={{textAlign: "center", marginTop: "20px"}}>
                        <Button className={"primary"} style={{backgroundColor: "rgb(36, 96, 121)", color: "white"}} onClick={() => this.runRuleEngine()}>Run Rule</Button>
                    </div>
                    {
                        this.state.camRuleEngineData && Array.isArray(this.state.camRuleEngineData) && this.state.camRuleEngineData.length ? <React.Fragment><Row>
                            <div>
                                <h3>Rule Engine Output</h3>
                            </div>
                            <hr />
                            <Table columns={columns} dataSource={this.state.camRuleEngineData} pagination={false} />
                        </Row>
                            <Row>
                                <div style={{marginTop: "30px"}}>
                                    <h3>Please select FI to transfer the case to</h3>
                                </div>
                                <Row style={{ marginTop: "20px" }}>
                                    <Col span={8} style={{textAlign: "center"}}>
                                        <h4>Send case to:</h4>
                                    </Col>
                                    <Col span={8} style={{textAlign: "center"}}>
                                        {
                                            this.state.bankListing && this.state.bankListing.length ? <Select onChange={(value) => this.setState({selectedBank: value})} style={{ minWidth: "200px" }}>
                                            {
                                                this.state.bankListing.map((item) => {
                                                    return (
                                                        <Select.Option key={item.id} value={item.id}>{item.name}</Select.Option>
                                                    )
                                                })
                                            }
                                        </Select>:null
                                        }
                                    </Col>
                                    <Col span={8} style={{textAlign: "center"}}>
                                        <Button className={"primary"} style={{ backgroundColor: "rgb(36, 96, 121)", color: "white" }} onClick={() => this.submitBank()}>Send</Button>
                                    </Col>
                                </Row>
                            </Row>
                        </React.Fragment>:null}
                </Col>
            </Row>
        );
    }
}

CamEngineTab.propTypes = {
};

const mapStateToProps = (state, props) => {
    const companyId = state.caseDetails &&
        state.caseDetails.getIn([Number(props.caseId), "data", "company"]);
    const caseDetail = state.caseDetails.getIn([Number(props.caseId), "data"]);
    const anchors = caseDetail.anchors_list.map(_ => _.split("|")[0]).join(", ");
    const company = state.companies.getIn([companyId, "data"]);
    return {
        scorecard: state.scorecard.get(props.caseId),
        supplyChain: state.supplyChain.getIn(["records", props.caseId, "data"]),
        caseDetail,
        anchors,
        company
    }
};

const mapDispatchToProps = dispatch =>
    bindActionCreators(
        {

        },
        dispatch
    );

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(CamEngineTab);
